/**
 * Easely Parser - Expert Production Grade
 * v1.0.4 - Precision Data Extraction
 */
import { CONFIG } from '../core/config';
import { validator } from '../utils/validator';

export const parser = {
  /**
   * Main entry point: Converts HTML attributes into a GSAP-ready object
   */
  getSettings(el) {
    if (!el) return {};

    const getAttr = (suffix) => el.getAttribute(`${CONFIG.PREFIX}-${suffix}`);

    return {
      // 1. Identification & Identity
      type: el.getAttribute(CONFIG.PREFIX) || 'fade',
      
      // 2. Timing & Feel (Sanitized via Validator)
      duration: validator.positive(validator.number(getAttr('duration'), CONFIG.DEFAULT_DURATION)),
      delay: validator.positive(validator.number(getAttr('delay'), 0)),
      ease: validator.ease(getAttr('ease'), CONFIG.DEFAULT_EASE),
      
      // 3. Loop & Repeat Logic
      repeat: validator.number(getAttr('repeat'), 0),
      yoyo: el.hasAttribute(`${CONFIG.PREFIX}-yoyo`),

      // 4. Scroll Logic (The Expert Layer)
      scroll: el.hasAttribute(`${CONFIG.PREFIX}-scroll`) || el.getAttribute(`${CONFIG.PREFIX}-scroll`) === 'true',
      scrollStart: getAttr('start') || "top 85%",
      
      // NEW: Visual Debugging Marker Detection
      markers: el.getAttribute(`${CONFIG.PREFIX}-markers`) === 'true',
      
      // 'once' defaults to true unless explicitly told 'false'
      once: el.getAttribute(`${CONFIG.PREFIX}-once`) !== 'false',
      
      // 5. Scrub Handling (Smooth scrolling)
      scrub: this._parseScrub(el),

      // 6. Orchestration
      stagger: validator.positive(validator.number(getAttr('stagger'), 0)),
      
      // 7. Custom Logic Overrides
      customTo: this.parseCustomString(getAttr('to'))
    };
  },

  /**
   * Expert Scrub Parser: Handles instant (true) vs smoothed (1.5) scrolling
   */
  _parseScrub(el) {
    const attr = el.getAttribute(`${CONFIG.PREFIX}-scrub`);
    
    if (attr === null) return false;
    if (attr === '' || attr === 'true') return true;
    if (attr === 'false') return false;
    
    const val = parseFloat(attr);
    return isNaN(val) ? false : val;
  },

  /**
   * Sanitizes and converts CSS-style strings into JS Objects
   */
  parseCustomString(str) {
    if (!str) return {};
    
    const obj = {};
    const pairs = str.split(';');

    pairs.forEach(pair => {
      const parts = pair.split(':');
      if (parts.length !== 2) return;

      const key = parts[0].trim();
      const rawValue = parts[1].trim();

      if (key && rawValue) {
        const numericValue = parseFloat(rawValue);
        obj[key] = isNaN(numericValue) || rawValue.includes(' ') ? rawValue : numericValue;
      }
    });

    return obj;
  }
};